import DownloadIcon from '@mui/icons-material/Download'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import { DownloadItemProps } from './types'
import { downloadS3File } from './utils/downloadS3File'

export const DownloadItem = ({
  configurationUrl,
  id,
  onDownloadEnd,
}: DownloadItemProps): JSX.Element => {
  const { t } = useTranslation('features/history', { keyPrefix: 'builds' })
  const download = async (): Promise<void> => {
    try {
      await downloadS3File(configurationUrl)
    } catch (error: unknown) {
      throw new Error(
        `Error trying downloading configuration from  "${configurationUrl}": ${(error as Error).message}`,
      )
    } finally {
      onDownloadEnd()
    }
  }

  return (
    <ListItemButton
      data-cy={`download-cell-${id}`}
      icon={<DownloadIcon />}
      onClick={() => void download()}
      text={t('list.actionsCell.download')}
    />
  )
}
